import { com } from '@eidu/form'
import DraftFieldValue from '../../domain/entity/DraftFieldValue'
import EqualityHashMap from '../../util/EqualityHashMap'
import EntityWithLabelAndRelated from '../../domain/entity/EntityWithLabelAndRelated'
import EntityAutocomplete from './EntityAutocomplete'
import Field = com.eidu.sharedlib.entity.field.Field
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import EntityId = com.eidu.sharedlib.entity.EntityId
import entityIdFromStringOrNull = com.eidu.sharedlib.entity.entityIdFromStringOrNull

export type EntityFormReferenceInputProps = {
  field: Field
  fieldValue: DraftFieldValue | undefined
  referenceableEntityTypesById: ReadonlyMap<EntityTypeId, EntityType | null>
  referenceableEntitiesByTypeId: ReadonlyMap<EntityTypeId, ReadonlyMap<EntityId, EntityWithLabelAndRelated>>
  selectedEntity?: EntityWithLabelAndRelated | null
  updateField: (value: DraftFieldValue) => void
  error: boolean
  setSearchQuery: (query: string) => void
  loadMore?: () => void
  hasMore?: boolean
  loading?: boolean
  disabled?: boolean
}

const EntityFormReferenceInput = ({
  field,
  fieldValue,
  referenceableEntitiesByTypeId,
  referenceableEntityTypesById,
  selectedEntity,
  updateField,
  error,
  setSearchQuery,
  loadMore,
  hasMore = false,
  loading = false,
  disabled = false,
}: EntityFormReferenceInputProps) => {
  const selectedId = fieldValue?.value?.let((it) => entityIdFromStringOrNull(it) ?? undefined)

  const entitiesById = new EqualityHashMap(
    (field.validReferenceTypes
      ? [...referenceableEntitiesByTypeId.entries()].flatMap(([typeId, entities]) =>
          field.validReferenceTypes?.asJsReadonlySetView()?.has(typeId) ? [entities] : []
        )
      : [...referenceableEntitiesByTypeId.values()]
    ).flatMap((entityById) => [...entityById.entries()])
  )

  if (selectedEntity) {
    entitiesById.set(selectedEntity.entity.id, selectedEntity)
  }

  return (
    <EntityAutocomplete
      entitiesById={entitiesById}
      entityTypesById={referenceableEntityTypesById}
      value={selectedId}
      onChange={(id) => updateField({ fieldId: field.id, type: field.type, value: id?.toString() ?? '' })}
      onSearchChange={setSearchQuery}
      loadMore={loadMore}
      hasMore={hasMore}
      loading={loading}
      label={field.name}
      required={field.required}
      error={error}
      disabled={disabled}
    />
  )
}

export default EntityFormReferenceInput
